import React from "react";
import CookieNotice$ from "@deosite/components-new/CookieNotice";
import Button from "@deosite/components-new/buttons/Button";
import { useLoader } from "@deosite/api/hooks/common/useLoader";

const sharedStyles = {
  minWidth: "150px",
  maxWidth: ["150px", null, null, "100%", null, null]
};

const CookieNotice = props => {
  const { cookieNoticeLoaded } = useLoader();

  const propsExt = {
    ...props,
    confirmButton: (
      <Button
        data-test={"accept-cookies-button"}
        sx={{ ...sharedStyles }}
        disabled={!cookieNoticeLoaded}
      />
    ),
    manageButton: (
      <Button
        sx={{
          ...sharedStyles,
          mt: ["s6", 0, null, "s6", null, null],
          ml: [0, "s5", null, "s0", null, null],
          $outline: true
        }}
        disabled={!cookieNoticeLoaded}
      />
    )
  };
  return <CookieNotice$ {...propsExt} />;
};

export default CookieNotice;
